import axios, { AxiosResponse } from 'axios'
import {CarFilteredDTO, CreateCarRequest, ICarFilterModel, ICarModel, ICarStatusFilterModel, IExpenseFilterModel, IKmFilterModel, IServiceFilterModel, UpdateCarRequest} from './CarModel'
import { ApiResponse, PageResponse, PaginatedResponse } from '../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const CAR_CREATE_URL = `${API_URL}api/v1/car/create`
export const CAR_GET_ALL_URL = `${API_URL}api/v1/car/get`
export const CAR_DELETE_URL = `${API_URL}api/v1/car/delete/`
export const CAR_UPDATE_URL = `${API_URL}api/v1/car/update/`
export const CAR_FILTER_URL = `${API_URL}api/v1/car/filter`
export const CAR_GET_BY_ID_URL = `${API_URL}api/v1/car/getById/`
export const CAR_KM_FILTER_URL = `${API_URL}api/v1/car/getKmLog`
export const CAR_SERVICE_FILTER_URL = `${API_URL}api/v1/car/getServiceLog`
export const CAR_EXPENSE_FILTER_URL = `${API_URL}api/v1/car/getExpenseLog`

export async function getCarDefinitionById(carId: string){
  try {
    const response = await axios.get(`${CAR_GET_BY_ID_URL}${carId}`);
    return response.data.payload;
  } catch (error) {
    console.error('Araç bilgisi alınamadı:', error);
    throw error;
  }
}

export function createCar(car: CreateCarRequest): Promise<ApiResponse<ICarModel>> {
  return axios.post(CAR_CREATE_URL, car);
}

export function loadCars(page = 0, size = 10): Promise<ApiResponse<PaginatedResponse<ICarModel>>> {
  return axios.get(CAR_GET_ALL_URL, {
    params: { page, size }
  });
}

export function deleteCar(carId: string): Promise<ApiResponse<void>> {
  return axios.delete(`${CAR_DELETE_URL}/${carId}`);
}

export function updateCar(carId: string, car: UpdateCarRequest): Promise<ApiResponse<ICarModel>> {
  return axios.put(`${CAR_UPDATE_URL}/${carId}`, car);
}
/*
export function getCarById(carId: string): Promise<ApiResponse<Car>> {
  return axios.get(`${BASE_URL}/car/${carId}`);
}

export function getCarByPlate(plate: string): Promise<ApiResponse<Car>> {
  return axios.get(`${BASE_URL}/car/plate/${plate}`);
}

export function searchCars(searchTerm: string, page = 0, size = 10): Promise<ApiResponse<PaginatedResponse<Car>>> {
  return axios.get(`${BASE_URL}/car/search`, {
    params: { q: searchTerm, page, size }
  });
} 

export function updateCarDefinition(carId: string, definition: Partial<CarDefinition>): Promise<ApiResponse<Car>> {
  return axios.patch(`${BASE_URL}/car/${carId}/definition`, definition);
}

// Car Detail specific endpoints
export function updateCarDetail(carId: string, detail: Partial<CarDetail>): Promise<ApiResponse<Car>> {
  return axios.patch(`${BASE_URL}/car/${carId}/detail`, detail);
}

// Car Insurance specific endpoints
export function updateCarInsurance(carId: string, insurance: Partial<CarInsurance>): Promise<ApiResponse<Car>> {
  return axios.patch(`${BASE_URL}/car/${carId}/insurance`, insurance);
}

// Car Warning specific endpoints
export function updateCarWarning(carId: string, warning: Partial<CarWarning>): Promise<ApiResponse<Car>> {
  return axios.patch(`${BASE_URL}/car/${carId}/warning`, warning);
}

// Bulk operations
export function bulkDeleteCars(carIds: string[]): Promise<ApiResponse<void>> {
  return axios.delete(`${BASE_URL}/car/bulk`, {
    data: { ids: carIds }
  });
}

export function bulkUpdateCars(updates: Array<{id: string, data: UpdateCarRequest}>): Promise<ApiResponse<Car[]>> {
  return axios.patch(`${BASE_URL}/car/bulk`, updates);
}

// Export car data
export function exportCars(format: 'csv' | 'excel' = 'excel'): Promise<Blob> {
  return axios.get(`${BASE_URL}/car/export`, {
    params: { format },
    responseType: 'blob'
  });
}
*/

export async function filterCars(
  values: ICarFilterModel,
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<CarFilteredDTO>>>> {
  return axios.post(CAR_FILTER_URL, values, {
    params: {page, size, sort, order},
  })
}

export async function filterCarStatus(
  values: ICarStatusFilterModel,
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICarModel>>>> {
  return axios.post(CAR_FILTER_URL, values, {
    params: {page, size, sort, order},
  })
}

export async function filterKM(
  page = 0, 
  size = 5, 
  sort: string = 'endDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IKmFilterModel>>>> {
  return axios.get(CAR_KM_FILTER_URL, {
    params: { page, size, sort, order }
  });
}

export async function filterService(
  page = 0, 
  size = 5, 
  sort: string = 'date', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IServiceFilterModel>>>> {
  return axios.get(CAR_SERVICE_FILTER_URL, {
    params: { page, size, sort, order }
  });
}

export async function filterExpense(
  page = 0, 
  size = 5, 
  sort: string = 'date', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IExpenseFilterModel>>>> {
  return axios.get(CAR_EXPENSE_FILTER_URL, {
    params: { page, size, sort, order }
  });
}
 
